module.exports = __webpack_public_path__ + "static/img/wood42.e937162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood42.jpg
// module id = A8Uv
// module chunks = 0